import { toastConfig } from 'lib/reactToastify/config';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import useSprintStartMutation from 'features/sprint/hooks/mutation/useSprintStart';
import { useTimelineLink } from 'features/timeline/hooks/useTimelineLink';

type useSprintStartSubmitParams = {
  sprintId: string;
};

export const useSprintStartSubmit = ({
  sprintId,
}: useSprintStartSubmitParams) => {
  const navigate = useNavigate();

  const { mutateAsync: startSprint } = useSprintStartMutation();

  const timelineLink = useTimelineLink();

  return async () => {
    let toastId = toast.loading('Starting sprint...', toastConfig);

    try {
      await startSprint({ sprintId });

      toast.update(toastId, {
        render: 'Sprint started!',
        type: 'success',
        isLoading: false,
        icon: false,
        ...toastConfig,
      });

      navigate(timelineLink);
    } catch (err) {
      toast.update(toastId, {
        render:
          "There's an error with starting sprint. Please try again later.",
        type: 'error',
        isLoading: false,
        icon: false,
        ...toastConfig,
      });
    }
  };
};
